import './App.css';
import {Route, Switch} from 'react-router';
import StateWise from './Statewise.jsx';
import Header from './html/Header.jsx';
import About from './html/About.jsx';
import Vaccination from './html/Vaccination.jsx';
import Home from './html/Home.jsx';
import Footer from './html/Footer.jsx';
import Pincode from './html/Pincode';
import District from './html/District';


function App(props) {
  return (
    <>
    <Header />
    <Switch>
      <Route exact path="/about" component={About} {...props} />
      <Route exact path="/vaccination" component={Vaccination} {...props} />
      <Route exact path="/statewise" component={StateWise} {...props} />
      <Route exact path="/vaccination/pincode" component={Pincode} {...props} />
      <Route exact path="/vaccination/district" component={District} {...props} />
      <Route exact path="/vaccination/*" component={Vaccination} {...props} /> 
      <Route exact path="/" component={Home} {...props} />

    </Switch>
    <Footer />
    </>
    
  );
}
export default App;